"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var Typename_1 = require("../../types/enums/Typename");
var ramda_1 = require("ramda");
var config_1 = __importStar(require("../../config"));
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
var getVodPlaybackMetadata_1 = __importDefault(require("./queries/getVodPlaybackMetadata"));
var getLivePlaybackMetadata_1 = __importDefault(require("./queries/getLivePlaybackMetadata"));
var stopVodPlaybackMetadata_1 = __importDefault(require("./queries/stopVodPlaybackMetadata"));
var stopLivePlaybackMetadata_1 = __importDefault(require("./queries/stopLivePlaybackMetadata"));
var refreshLinearPlaybackHeartbeat_1 = __importDefault(require("./queries/refreshLinearPlaybackHeartbeat"));
var refreshVodPlaybackHeartbeat_1 = __importDefault(require("./queries/refreshVodPlaybackHeartbeat"));
var getOfflinePlaybackMetadata_1 = __importDefault(require("./queries/getOfflinePlaybackMetadata"));
var selectors_1 = require("../devices/selectors");
exports.refreshPlaybackHeartbeat = function (mediaAssetId, isLive, deviceId) {
    return api_1.createApiAction(constants_1.REFRESH_PLAYBACK_HEARTBEAT, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: isLive ? refreshLinearPlaybackHeartbeat_1.default() : refreshVodPlaybackHeartbeat_1.default(),
            variables: { assetId: mediaAssetId, deviceId: deviceId, channelId: mediaAssetId },
        },
        meta: { mediaAssetId: mediaAssetId, isLive: isLive, deviceId: deviceId },
        authenticated: true,
        graphQL: true,
    });
};
// Making playbackDevice optional beacuse we will be remving this in future
exports.fetchPlaybackMeta = function (mediaAssetId, isLive, drmType, deviceId, encoding, appId, adParams, timeShiftedView) { return function (dispatch, getState) {
    var playbackDevice = selectors_1.getPlaybackDeviceInfo(getState());
    return dispatch(api_1.createApiAction(constants_1.FETCH_PLAYBACK_META, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: isLive ? getLivePlaybackMetadata_1.default() : getVodPlaybackMetadata_1.default(drmType),
            variables: __assign({ assetId: mediaAssetId, deviceId: deviceId,
                encoding: encoding, channelId: mediaAssetId, // applicable only for Live Playback
                appId: appId,
                adParams: adParams,
                timeShiftedView: timeShiftedView }, (playbackDevice && { playbackDevice: playbackDevice })),
        },
        meta: { mediaAssetId: mediaAssetId, isLive: isLive },
        authenticated: true,
        graphQL: true,
        onSuccess: function (playbackDispatch, _a) {
            var payload = _a.payload;
            var _b, _c, _d, _e;
            if (ramda_1.equals((_b = payload === null || payload === void 0 ? void 0 : payload.startVodPlayback) === null || _b === void 0 ? void 0 : _b.__typename, Typename_1.Typename.ConcurrencyError) ||
                ramda_1.equals((_c = payload === null || payload === void 0 ? void 0 : payload.startLinearPlayback) === null || _c === void 0 ? void 0 : _c.__typename, Typename_1.Typename.ConcurrencyError) ||
                ramda_1.equals((_d = payload === null || payload === void 0 ? void 0 : payload.startVodPlayback) === null || _d === void 0 ? void 0 : _d.__typename, Typename_1.Typename.SubscriptionNeeded) ||
                ramda_1.equals((_e = payload === null || payload === void 0 ? void 0 : payload.startLinearPlayback) === null || _e === void 0 ? void 0 : _e.__typename, Typename_1.Typename.SubscriptionNeeded)) {
                return;
            }
            playbackDispatch(exports.refreshPlaybackHeartbeat(mediaAssetId, isLive, deviceId));
        },
    }));
}; };
exports.fetchOfflinePlaybackMeta = function (mediaAssetId, drmType, deviceId, usePlaybackDevice) {
    if (usePlaybackDevice === void 0) { usePlaybackDevice = false; }
    return function (dispatch, getState) {
        var playbackDevice = usePlaybackDevice ? selectors_1.getPlaybackDeviceInfo(getState()) : null;
        return dispatch(api_1.createApiAction(constants_1.FETCH_OFFLINE_PLAYBACK_META, {
            baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
            params: {
                query: getOfflinePlaybackMetadata_1.default(drmType),
                variables: __assign({ assetId: mediaAssetId, deviceId: deviceId }, (playbackDevice && { playbackDevice: playbackDevice })),
            },
            meta: { mediaAssetId: mediaAssetId },
            authenticated: true,
            graphQL: true,
        }));
    };
};
exports.stopPlayback = function (mediaAssetId, isLive, deviceId, isKeepalive) {
    if (isKeepalive === void 0) { isKeepalive = false; }
    return api_1.createApiAction(constants_1.STOP_PLAYBACK, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: isLive ? stopLivePlaybackMetadata_1.default() : stopVodPlaybackMetadata_1.default(),
            variables: { assetId: mediaAssetId, channelId: mediaAssetId, deviceId: deviceId },
        },
        meta: { mediaAssetId: mediaAssetId },
        authenticated: true,
        graphQL: true,
        fetchOptions: isKeepalive ? { keepalive: true } : undefined,
    });
};
exports.removePlaybackMeta = function (mediaAssetId) {
    return toolkit_1.createAction(constants_1.REMOVE_PLAYBACK_META)(mediaAssetId);
};
// for downloads
exports.setPlaybackMeta = function (mediaAssetId, playback) {
    return toolkit_1.createAction(constants_1.SET_PLAYBACK_META)({ mediaAssetId: mediaAssetId, playback: playback });
};
exports.setPlaybackHeartbeat = function (mediaAssetId, heartBeatInterval) {
    return toolkit_1.createAction(constants_1.SET_PLAYBACK_HEARTBEAT)({ mediaAssetId: mediaAssetId, heartBeatInterval: heartBeatInterval });
};
exports.setTextTracks = function (mediaAssetId, textTracks) {
    return toolkit_1.createAction(constants_1.SET_TEXT_TRACKS)({ mediaAssetId: mediaAssetId, textTracks: textTracks });
};
exports.clearTextTracks = function () { return toolkit_1.createAction(constants_1.CLEAR_TEXT_TRACKS)({}); };
exports.setAudioTracks = function (audioTracks) {
    return toolkit_1.createAction(constants_1.SET_AUDIO_TRACKS)(audioTracks);
};
exports.clearAudioTracks = function () { return toolkit_1.createAction(constants_1.CLEAR_AUDIO_TRACKS)({}); };
//# sourceMappingURL=actions.js.map